import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const features = [{
  icon: '📋',
  title: 'Paso a Paso Sin Asumir Nada',
  subtitle: 'Razón #1',
  desc: 'Instrucciones A-Z redactadas como si nadie supiera nada de jabones. <strong class="text-brand-brown">Sin "ya sabés cómo" ni pasos omitidos.</strong> Es como tener una maestra artesana tomándote de la mano en cada etapa.'
}, {
  icon: '💰',
  title: 'Cero Desperdicio de Dinero',
  subtitle: 'Razón #2',
  desc: 'Cada receta trae la lista exacta de ingredientes con cantidades precisas. <strong class="text-brand-brown">Comprás solo lo que vas a usar.</strong> Nada de lotes perdidos ni materiales acumulando polvo en tu cocina.'
}, {
  icon: '🧼',
  title: '50+ Recetas Probadas para Vender',
  subtitle: 'Razón #3',
  desc: 'Desde jabones básicos hasta <strong class="text-brand-brown">productos Premium con aceites esenciales y arcillas.</strong> Hay recetas para todos los niveles — con técnicas de frío, caliente, glicerina y más.'
}];
export function ProductFeatures() {
  return;
}